import type { A11yIgnoredViolation } from '@overlayqa/shared';
import { useApiQuery } from './useApiQuery';
import { useApiMutation } from './useApiMutation';
import { a11yIgnoredDashboardApi } from '../lib/api/a11yIgnored';
import { log } from '@/lib/logger';

log.info('[useA11yIgnored] Module loaded');

const queryKey = (projectId: string) => ['a11y-ignored', projectId] as const;

export function useA11yIgnored(projectId: string) {
  log.info('[useA11yIgnored] useA11yIgnored called with projectId:', { projectId });
  return useApiQuery<A11yIgnoredViolation[]>({
    queryKey: queryKey(projectId),
    queryFn: (token) => a11yIgnoredDashboardApi.list(token, projectId),
    enabled: Boolean(projectId),
  });
}

export function useUnignoreA11y(projectId: string) {
  log.info('[useA11yIgnored] useUnignoreA11y called with projectId:', { projectId });
  return useApiMutation<{ deletedCount: number }, string[]>({
    mutationFn: (token, ids) => a11yIgnoredDashboardApi.unignoreBulk(token, projectId, ids),
    invalidateKeys: [queryKey(projectId)],
  });
}
